/* styles/annotations */ function _(require, module, exports) {
    require(311) /* ./root */;
    var _a = require(5) /* ../core/dom */;
    _a.styles.append(".bk-root .bk-shading {\n  position: absolute;\n  display: block;\n  border: 1px dashed green;\n}\n");
    exports.bk_annotation = "bk-annotation";
    exports.bk_shading = "bk-shading";
    exports.bk_annotation_child = "bk-annotation-child";
}
